import { useFetchTemplate } from './useFetchTemplate'

const createContractFromTemplate = () => {
  const { createContractFromTemplate: mutationFn } = useFetchTemplate()
  return useMutation({ mutationFn })
}

export const useMutationTemplate = {
  createContractFromTemplate,
}
